import React, { useContext, useEffect, useState } from "react";
import { Link, useOutletContext } from "react-router-dom";
import "./dashboard.scss";
import "./dashboard.css";
import thumnail from "../../assets/myAnalytics/tumbnail.png";
import profile from "../../assets/myAnalytics/profile.png";
import { message } from "antd";
import { ThemeContext } from "../../context/themeProvider";
import userService from "../../services/userService";

const MyAnalytics = (props) => {
  const outletProps = useOutletContext();
  const { colorBgContainer } = outletProps;
  const { headerTitle, setHeaderTitle } = props;
  useEffect(() => {
    // Update the header title when the component mounts
    setHeaderTitle("My Analytics");
    return () => {
      // Optionally, reset the header title when the component unmounts
      setHeaderTitle("");
    };
  }, [headerTitle]);

  const { setLoading } = useContext(ThemeContext);
  const [watchedVideos, setAllWatchVideo] = useState([]);
  useEffect(() => {
    getBlogData();
  }, []);

  const getBlogData = async () => {
    try {
      setLoading(true);

      const response = await userService.getAllWatchedVideos();

      if (response.error) {
        message.destroy();
        message.error(response?.error?.message || "Something went wrong!");
      } else {
        setAllWatchVideo(response?.data);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
    setLoading(false);
  };

  console.log(watchedVideos);
  return (
    <section
      style={{ background: colorBgContainer }}
      className="my-analytics-container"
    >
      {watchedVideos.length > 0 ? (
        <div className="row video-card-container d-flex justify-content-start mb-3">
          {watchedVideos.map((data) => (
            <div className="col-md-6 col-lg-4 col-xl-4 col-xxl-3">
              <div className="video-card">
                <img src={data?.videoId?.thumbnail} alt="" />
                <h5>{data?.videoId?.name?.slice(0, 30) + "..."}</h5>
                <div className="video-profile">
                  <img src={data?.videoId?.channelDp} alt="" />
                  <p>{data?.videoId?.channelName}</p>
                </div>
                <Link to={`/dashboard/videoAnalytics/${data?.videoId?._id}`}>
                  <button>Video Analytics</button>
                </Link>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div
          style={{ height: "80vh" }}
          className="row d-flex  align-items-center text-center text-secondary"
        >
          <h3 sty>No analytics availabe!</h3>
        </div>
      )}
    </section>
  );
};

export default MyAnalytics;
